// extracted by mini-css-extract-plugin
module.exports = {"block":"block__MTF2m6doPZGtm","content":"content__zIYH1YtTHPWPm"};